import React, { useState } from "react";
import {
  Paper,
  Button,
  Typography,
  Box,
  Menu,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { Create, Delete, CropSquare, Timeline } from "@material-ui/icons";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const FloodControls = ({
  onStartDrawing,
  onUndo,
  isDrawing,
  hasShape,
  onDataUpdate,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedGeom, setSelectedGeom] = useState(null);
  const [startDate, setStartDate] = useState(new Date("2000-01-01"));
  const [endDate, setEndDate] = useState(new Date());
  const [threshold, setThreshold] = useState(30);

  const handleStartDrawing = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleModeSelect = (mode) => {
    setAnchorEl(null);
    onStartDrawing(mode);
  };

  const handleClear = () => {
    onUndo();
    setSelectedGeom(null);
  };

  const handleUpdate = () => {
    onDataUpdate({ selectedGeom, startDate, endDate, threshold });
  };

  return (
    <Box
      style={{
        marginTop: 60,
        position: "absolute",
        left: 16,
        top: 16,
        width: "320px",
        zIndex: 1000,
      }}
    >
      <Paper style={{ padding: 16, marginBottom: 8 }} elevation={0}>
        <Typography variant="subtitle1">Flood Analysis Controls</Typography>

        {/* Drawing Controls */}
        {!hasShape ? (
          <>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Create />}
              onClick={handleStartDrawing}
            >
              Draw Area
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem onClick={() => handleModeSelect("polygon")}>
                <Timeline /> Polygon
              </MenuItem>
              <MenuItem onClick={() => handleModeSelect("rectangle")}>
                <CropSquare /> Rectangle
              </MenuItem>
            </Menu>
          </>
        ) : (
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<Delete />}
            onClick={handleClear}
          >
            Clear Selection
          </Button>
        )}

        {/* Date Selection */}
        {hasShape && (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              variant="inline"
              format="yyyy-MM-dd"
              label="Start Date"
              value={startDate}
              onChange={setStartDate}
              fullWidth
            />
            <KeyboardDatePicker
              variant="inline"
              format="yyyy-MM-dd"
              label="End Date"
              value={endDate}
              onChange={setEndDate}
              fullWidth
            />
          </MuiPickersUtilsProvider>
        )}

        {/* Threshold Selection */}
        {hasShape && (
          <TextField
            type="number"
            label="Flood Threshold"
            value={threshold}
            onChange={(e) => setThreshold(Number(e.target.value))}
            fullWidth
          />
        )}

        {/* Update Button */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdate}
          fullWidth
        >
          Run Analysis
        </Button>
      </Paper>
    </Box>
  );
};

export default FloodControls;
